import _, { isEmpty, isNil } from 'lodash-es';
import { useRef, useState } from 'react';

import {
  type ValidationMessage,
  getErrorConstraints,
  getValidationMessages,
} from '../utils/validation';
import PasswordValidator from '../validators/PasswordValidator';

const PASSWORD_PROPERTY = 'password';
const VALIDATION_TYPES = ['containsTwoOrMoreTypes', 'isLength', 'matches'] as const;
export type ValidationTypes = (typeof VALIDATION_TYPES)[number];

export function usePasswordValidation() {
  const passwordValidatorRef = useRef(new PasswordValidator());
  const [validationMessages, setValidationMessages] = useState<
    ValidationMessage<ValidationTypes>[]
  >(getValidationMessages([...VALIDATION_TYPES], passwordValidatorRef.current, PASSWORD_PROPERTY));

  const onValidate = (value: string) => {
    passwordValidatorRef.current[PASSWORD_PROPERTY] = value;
    const updatedValidationMessages = updateValidationMessages(value);
    setValidationMessages(updatedValidationMessages);
  };

  const updateValidationMessages = (value: string) => {
    if (_.isEmpty(value)) {
      return _.map(validationMessages, (origin) => {
        origin.status = 'help';

        return origin;
      });
    }

    const constraints = getErrorConstraints(passwordValidatorRef.current, PASSWORD_PROPERTY);

    return _.map(validationMessages, (origin) => {
      const errorMessage = constraints?.[origin.type];

      if (!isNil(errorMessage) && !isEmpty(errorMessage)) {
        origin.message = errorMessage;
      }

      origin.status =
        _.isUndefined(constraints) || !_.has(constraints, origin.type) ? 'success' : 'error';

      return origin;
    });
  };

  const clear = () => {
    setValidationMessages(
      validationMessages.map((props) => ({
        ...props,
        status: 'help',
      })),
    );
  };

  return { onValidate, validationMessages, clear };
}
